<div *ngFor="let group of schoolTables" class="aya-countries-school-list">
  <div *ngFor="let school of group.schools" class="aya-countries-school-list__school">
    <div class="aya-countries-school-list__school__header">
      <lx-price-lists-portal-aya-school-header [group]="group" [school]="school"></lx-price-lists-portal-aya-school-header>
    </div>
    <div class="aya-countries-school-list__school__table">
      <lx-price-lists-portal-aya-school-table [table]="school"></lx-price-lists-portal-aya-school-table>
    </div>
  </div>
</div>
